import { render, staticRenderFns } from "./AtomProjectPortfolio.vue?vue&type=template&id=0531af78&"
import script from "./AtomProjectPortfolio.vue?vue&type=script&lang=js&"
export * from "./AtomProjectPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./AtomProjectPortfolio.vue?vue&type=style&index=0&id=0531af78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomVerticalLine: require('/app/components/atoms/common/AtomVerticalLine.vue').default,AtomsCommonAtomContentText: require('/app/components/atoms/common/AtomContentText.vue').default,AtomsCommonAtomButtonLink: require('/app/components/atoms/common/AtomButtonLink.vue').default})
